// extracted by mini-css-extract-plugin
module.exports = {"input":"Phone_input_1Hn_x","icon":"Phone_icon_3w22J"};